import {EditModel} from "./EditModel";
import {Reader} from "../../entities/Reader";
import {Location} from "../../entities/Location";
import {AlertingAction} from "../../entities/AlertingAction";
import {Antenna} from "../../entities/Antenna";
import {ApplicationSetting} from "../../entities/ApplicationSetting";
import {DeviceProperty, DevicePropertyValue, DeviceSetting} from "../../entities/DeviceSetting";
import {ReaderService} from "../../services/ReaderService";
import {LocationService} from "../../services/LocationService";
import {AlertingActionService} from "../../services/AlertingActionService";
import {AntennaService} from "../../services/AntennaService";
import {ApplicationSettingService} from "../../services/ApplicationSettingService";
import {NotificationService} from "../../services/NotificationService";

export class EditReaderModel extends EditModel<Reader> {
    DISABLEDDEFAULT = "DISABLED";
    networkHostnameEnabled: boolean = true;
    networkPortEnabled:boolean
    networkUsernameEnabled:boolean = true;
    networkPasswordEnabled:boolean = true;
    entityId:number;
    locations:Location[];
    alertingActions:AlertingAction[];
    antennas:Antenna[];
    applicationSetting:ApplicationSetting;
    dateFormat:string = "MM-dd-yyyy HH:mm:ss";
    currentDeviceSetting:DeviceSetting;
    devicePropertyValues:any[] = [];
    connections:string[] = [];
    //selectedConnection:string;
    readerModels:string[] = ['Alien','Impinj Octane','InfinID VG100-1','InfinID VG200-1','InfinID VGGPS200-1','LLRP','Motorola XR400'];
    static $inject = ['$q','ReaderService','LocationService','AlertingActionService','AntennaService','ApplicationSettingService','NotificationService'];
    constructor($q:ng.IQService,
                public service:ReaderService,
                public locationService:LocationService,
                public alertingActionService:AlertingActionService,
                public antennaService:AntennaService,
                public applicationSettingService:ApplicationSettingService,
                public notifyService:NotificationService){
        super($q, service, Reader);
    }
    addAntenna(){
        var aaId = this.alertingActions.length > 0 ? this.alertingActions[0].id : null;
        var locId = this.locations.length > 0 ? this.locations[0].id : null;
        var antenna:Antenna = new Antenna(this.entity.id,null,this.antennas.length+1,aaId,locId);
        this.antennas.push(antenna);
    }
    removeAntenna(index:number){
        this.antennas.splice(index,1);
        for(var i:number=index; i<this.antennas.length;i++){
            var antenna = this.antennas[i];
            antenna.number--;
        }
    }
    selectedModelChanged(initialLoad: boolean = false): void {
        var model = this.entity.readerModel;
        //console.log("selectedModelChanged=" + model);
        //console.log("selectedModelChanged = " + model);
        //find the Device
        var deviceSetting:DeviceSetting = null;
        for (var i = 0; i < this.deviceSettings.length; i++) {
            var tempDeviceSetting = this.deviceSettings[i];
            if (tempDeviceSetting.model == model) {
                deviceSetting = tempDeviceSetting;
                this.currentDeviceSetting = tempDeviceSetting;
            }
        }//for
        if (deviceSetting != null) {
            //if have a DeviceSetting, set network connections            
            if (!initialLoad)
                this.setDefaultNetworkValues();
            //now go ahead and set all the devicePropertyValues
            this.setDevicePropertyValues();
        }
        else{
            alert("model not found");
        }
        return null;
    }
    setDevicePropertyValues() {
        var deviceSetting: DeviceSetting = this.currentDeviceSetting;
        this.devicePropertyValues.splice(0, this.devicePropertyValues.length);
        for (var i = 0; i < deviceSetting.deviceProperties.length; i++) {
            var dpValue = deviceSetting.deviceProperties[i];
            var dpv = new DevicePropertyValue(dpValue);
            var entityDpv = this.getEntityDeviceSettingValue(dpv.storageName);
            if (this.entity.deviceSettings != null)
                dpv.setValue(this.entity.deviceSettings);
            else
                dpv.setValue(deviceSetting.defaultPropertyValues);
            this.devicePropertyValues.push(dpv);
        }
    }
    getEntityDeviceSettingValue(name:string):string{
      var dsString = this.entity.deviceSettings;
      if(dsString == null || dsString.length == 0)
        return null;
      var dsPairs = dsString.split("|");
      var returnVal = null;
      for(var i:number = 0; i<dsPairs.length; i++){
        var currPair = dsPairs[i].split("=");
        if(currPair.length == 2 && currPair[0] == name){
          return currPair[1];
        }
      }
      return returnVal;
    }    
    getDefaultPortSettings() {
        //this function assumes the currentDeviceSettings is set for current model
        return this.currentDeviceSetting.defaultNetworkSettings;
    }
    saveDevicesettings(){
        //console.log("save device settings");
        var returnVal = "";
        for (var i = 0; i < this.devicePropertyValues.length; i++) {
            var dpValue = this.devicePropertyValues[i];
            var storageName = dpValue.storageName;
            var val = dpValue.value;
            returnVal += storageName + "=" + val;
            if (i < this.devicePropertyValues.length - 1)
                returnVal += "|";
        }
        //console.log("setting deviceSettingString " + returnVal);
        this.entity.deviceSettings = returnVal;
    }
    setDefaultNetworkValues() {
        //console.log("setting port string for " + this.selectedModel);
        //set defaults
        var dps = this.getDefaultPortSettings();
        if (dps != null) {
            var defaultSettingsValues = dps.split(",");
            this.setNetworkValues(defaultSettingsValues[0], defaultSettingsValues[1], defaultSettingsValues[2], defaultSettingsValues[3]);
        }
    }
    setNetworkValues(myHostname:string, myPort:string, myUsername:string, myPassword:string) {
        //this.setComValues(this.DISABLEDDEFAULT, this.DISABLEDDEFAULT, this.DISABLEDDEFAULT);
        //console.log("setting myHostname=" + myHostname + ", myPort=" + myPort + ", myUsername=" + myUsername + " myPassword=" + myPassword);
        if (myHostname == this.DISABLEDDEFAULT) {
            this.entity.ipAddress = "";
            this.networkHostnameEnabled = false;
        }
        else {
            this.entity.ipAddress = myHostname;
            this.networkHostnameEnabled = true;
        }
        if (myPort == this.DISABLEDDEFAULT) {
            this.entity.port = "";
            this.networkPortEnabled = false;
        }
        else {
            this.entity.port = myPort;
            this.networkPortEnabled = true;
        }
        if (myUsername == this.DISABLEDDEFAULT) {
            this.entity.username = "";
            this.networkUsernameEnabled = false;
        }
        else {
            this.entity.username = myUsername;
            this.networkUsernameEnabled = true;
        }
        if (myPassword == this.DISABLEDDEFAULT) {
            this.entity.password = "";
            this.networkPasswordEnabled = false;
        }
        else {
            this.entity.password = myPassword;
            this.networkPasswordEnabled = true;
        }
    }
    loadData(entityId:number):ng.IPromise<boolean>{
        return super.loadData(entityId).then((ok)=>{
          var locationPromise:ng.IPromise<any> = this.locationService.getAll();
          var alertingActionPromise:ng.IPromise<any> = this.alertingActionService.getAll();
          var antennasPromise:ng.IPromise<any> = this.entityId != null ? this.antennaService.GetByReader(this.entityId) : this.$q.when<Antenna[]>([]);
          return this.$q.all([locationPromise,alertingActionPromise,antennasPromise, this.applicationSettingService.getCached()]).then((data)=>{
            this.locations = data[0];
            data[1].unshift(new AlertingAction(null,""));
            this.alertingActions = data[1];
            this.antennas = data[2];
            this.applicationSetting = data[3];
            this.dateFormat = this.applicationSetting.dateFormat;
            this.selectedModelChanged(true);
            if (entityId == null)
                this.setDefaultNetworkValues();
            return this.$q.when<boolean>(true);
          }).catch((exc)=>{
            return this.$q.reject(exc);
          });
        });
    }
    isHex(inputString:string):boolean{
        if(inputString == null || inputString.length == 0)
            return true;
        inputString = inputString.replace(' ', '');
        var re = /^[0-9a-f]+$/ig
        if(re.test(inputString)) {
            return true;
        } else {
            return false;
        }

        re.lastIndex = 0; // be sure to reset the index after using .text()
    }
    verifyData():ng.IPromise<boolean>{
      if(this.entity.name == null || this.entity.name.length == 0){
        this.notifyService.notifyError("Please enter a Name.");
        return this.$q.when<boolean>(false);
      }
      if(this.entity.readerModel == "InfinID VGGPS200-1"){
          if(this.entity.vTagGpsGatewayID == null || this.entity.vTagGpsGatewayID.length != 16){
              this.notifyService.notifyError("VTag GPS Gateway ID must be 16 characters.");
              return this.$q.when<boolean>(false);
          }
          if(!this.isHex(this.entity.vTagGpsGatewayID)){
              this.notifyService.notifyError("VTag GPS Gateway ID must be all Hex characters.");
              return this.$q.when<boolean>(false);
          }
          this.entity.useWithService = this.entity.vTagGpsGatewayID;
      }
      if(this.entity.locationID == null ){
        this.notifyService.notifyError("Please choose a location.");
        return this.$q.when<boolean>(false);
      }
      return this.service.getByName(this.entity.name).then((reader)=>{
        if(reader != null && reader.id != this.entity.id)
        {
          this.notifyService.notifyError("This reader name has already been used.");
          return this.$q.when<boolean>(false);
        }
        else
          return this.$q.when<boolean>(true);
      })
    }
    saveData():ng.IPromise<boolean>{
      return super.saveData().then((ok)=>{
        if(!ok)
          return this.$q.when<boolean>(false);
        var antennaPromise:ng.IPromise<void> = this.entityId == null ? this.$q.when() : this.antennaService.InsertByReader(this.entityId, this.antennas);
        return antennaPromise.then(()=>{
          return this.$q.when<boolean>(true);
        })
      });
    }
    deviceSettings:DeviceSetting[] = [
        new DeviceSetting("Alien", [
            new DeviceProperty("Tag Timeout(s)", "INTEGER", "TagTimeout"), ],
            "10.10.10.10,23,alien,password","TagTimeout=60"),
        new DeviceSetting("LLRP", [
            new DeviceProperty("Tag Timeout(s)", "INTEGER", "TagTimeout"),
            new DeviceProperty("Transmit Power(1-100)", "INTEGER", "PW"),
            new DeviceProperty("Trigger Sensor", "CHOICE(Always On|GPI1)", "TS"),
            new DeviceProperty("Trigger Read Time(s)", "INTEGER", "TRT"),
            new DeviceProperty("Direction Sensor", "CHOICE(None|GPI1::Inner GPI2::Outer)", "DS"),
            new DeviceProperty("Direction Spacing Time(ms)", "INTEGER", "DST"),
            new DeviceProperty("GPO1 Default State", "CHOICE(Do Nothing|Low|High)", "GPO1"),
            new DeviceProperty("GPO2 Default State", "CHOICE(Do Nothing|Low|High)", "GPO2"),
            new DeviceProperty("Tag Process Mode", "CHOICE(Single|Batch)", "TagProcessMode"),
            new DeviceProperty("Tag Read Update Location", "CHOICE(Yes|No)", "TagReadUpdateLocation")],
            "10.10.10.10,DISABLED,DISABLED,DISABLED",
            "TagTimeout=60|PW=100|TS=Always On|TRT=30|DS=None|DST=2000"),
        new DeviceSetting("Impinj Octane", [
            new DeviceProperty("Tag Timeout(s)", "INTEGER", "TagTimeout"),
            new DeviceProperty("Reader Mode", "CHOICE(NORMAL|DOPPLER|PHASE)", "ReaderMode"),
            new DeviceProperty("Reader Power(1-100)", "INTEGER", "ReaderPower"),
            new DeviceProperty("Dir Min RSSI(-20 to -97)", "INTEGER", "DirectionMinRSSI"),
            new DeviceProperty("Search Mode", "CHOICE(SINGLE|DUAL)", "ReaderSearchMode"),
            new DeviceProperty("Tag Process Mode", "CHOICE(Single|Batch)", "TagProcessMode"),
            new DeviceProperty("Tag Read Update Location", "CHOICE(Yes|No)", "TagReadUpdateLocation"),
            new DeviceProperty("Filter Tags With No Directionality", "CHOICE(Yes|No)", "FilterNoDirection")],
            "10.10.10.10,DISABLED,DISABLED,DISABLED",
            "TagTimeout=60|ReaderMode=NORMAL|ReaderPower=100|DirectionMinRSSI=-97|ReaderSearchMode=SINGLE"),
        new DeviceSetting("InfinID VG100-1", [
            new DeviceProperty("Rate Limit Tag Commands", "CHOICE(DISABLE|ENABLE)", "RateLimit"),
            new DeviceProperty("Tag Process Mode", "CHOICE(Single|Batch)", "TagProcessMode"),
            new DeviceProperty("Tag Read Update Location", "CHOICE(Yes|No)", "TagReadUpdateLocation")],
            "10.10.10.10,8422,admin,change",
            ""),
        new DeviceSetting("InfinID VG200-1", [
            new DeviceProperty("Rate Limit Tag Commands", "CHOICE(DISABLE|ENABLE)", "RateLimit"),
            new DeviceProperty("Tag Process Mode", "CHOICE(Single|Batch)", "TagProcessMode"),
            new DeviceProperty("Tag Read Update Location", "CHOICE(Yes|No)", "TagReadUpdateLocation")],
            "DISABLED,DISABLED,,",
            ""),
        new DeviceSetting("InfinID VGGPS100-1", [
            new DeviceProperty("Rate Limit Tag Commands", "CHOICE(DISABLE|ENABLE)", "RateLimit"),
            new DeviceProperty("Tag Process Mode", "CHOICE(Single|Batch)", "TagProcessMode"),
            new DeviceProperty("Tag Read Update Location", "CHOICE(Yes|No)", "TagReadUpdateLocation")],          
          "10.10.10.10,8422,admin,change",
          ""),
        new DeviceSetting("InfinID VGGPS200-1", [],
            "DISABLED,DISABLED,DISABLED,DISABLED",
            ""),
        new DeviceSetting("InfinID BLE", [],
            "DISABLED,DISABLED,DISABLED,DISABLED",
            ""),
        new DeviceSetting("Motorola XR400", [new DeviceProperty("Tag Timeout(s)", "INTEGER", "TagTimeout"), ],            
            "10.10.10.10,3000,DISABLED,DISABLED",
            "TagTimeout=60")
    ];
}
